import { Button, Form, Input, Select, Table } from 'antd'
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import styles from './index.module.less'
import _, { cloneDeep, isArray, isEmpty, uniqueId } from 'lodash'
import tagsMap from '../../utils'
const { TextArea } = Input
interface IProps {
  submitData: any // 商品提交信息
  spaceId: string // 当前空间id
  type: string
  recordData: any
}
export default forwardRef(function SpaceApply(porps: IProps, ref) {
  const { submitData, spaceId, type, recordData } = porps
  const [form] = Form.useForm()
  const [columns, setColumns] = useState<any>([])
  const [newSpaceData, setNewSpaceData] = useState<any>([])
  const dataRef = useRef<any>([])
  dataRef.current = newSpaceData.list
  useEffect(() => {
    console.log(submitData, 'submitData')
    let newData = cloneDeep(submitData)
    let columns: any = []
    if (type === 'SUB') {
      columns = [
        {
          title: '序号',
          dataIndex: 'key',
          width: 60,
          render: (text, record, index) => index + 1,
        },
        {
          title: '项目类型',
          dataIndex: 'typeNameList',
          render: (text, record) => {
            text = text?.map((str: string) => (
              <div
                key={str}
                className={'normal_tag_style'}
                style={{
                  color: tagsMap[str]?.color,
                  backgroundColor: tagsMap[str]?.bgColor,
                  marginRight: '8px',
                }}
              >
                {tagsMap[str]?.name}
              </div>
            ))
            return <div>{text}</div>
          },
        },
        {
          title: '应用空间',
          dataIndex: 'itemId',
          width: 120,
          render: (text, record, index) => (
            <div>
              <Form.Item>
                <Select
                  style={{ width: 120 }}
                  onChange={e => handleChange(e, index)}
                  // allowClear
                  value={text}
                  options={submitData?.budgetItemList}
                  fieldNames={{ label: 'showName', value: 'id' }}
                />
              </Form.Item>
            </div>
          ),
        },
        {
          title: '最大可减量',
          dataIndex: 'availableQuantity',
          width: 100,
        },
        {
          title: '预算量计算式',
          dataIndex: 'budgetQtyFormular',
          width: 100,
          render: (text, record, index) => (
            <div>
              <Form.Item>
                <Input
                  disabled={newSpaceData.errMessage}
                  onChange={e => {
                    onChangeCalculate(index, e.target.value)
                  }}
                ></Input>
              </Form.Item>
            </div>
          ),
        },
        {
          title: '预算量',
          dataIndex: 'budgetQtyValue',
          width: 100,
          render: (text, record, index) => {
            if (text === false) {
              text = '计算式错误'
            }
            return (
              <div>
                <Form.Item>
                  <Input disabled value={text}></Input>
                </Form.Item>
              </div>
            )
          },
        },
        // {
        //   title: '单位',
        //   dataIndex: 'unitName',
        //   width: 80,
        //   ellipsis: {
        //     showTitle: true,
        //   },
        // },
        {
          title: '单价',
          dataIndex: 'saleCustPrice',
          width: 100,
          render: (text, record, index) => {
            return (
              <span>
                ￥{text || 0}/{record.unitName}
              </span>
            )
          },
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 100,
          render: (text, record, index) => (
            <div>
              <Form.Item>
                <TextArea
                  autoSize
                  disabled={newSpaceData.errMessage}
                  value={text}
                  maxLength={255}
                  onChange={e => {
                    let list: any = dataRef?.current || []
                    const newData = _.cloneDeep(list)
                    newData[index].remark = e.target.value
                    setNewSpaceData({ ...newSpaceData, list: newData })
                  }}
                ></TextArea>
              </Form.Item>
            </div>
          ),
        },
      ]
    } else {
      columns = [
        {
          title: '序号',
          dataIndex: 'key',
          width: 40,
          render: (text, record, index) => index + 1,
        },
        {
          title: (
            <span>
              <span style={{ color: 'red' }}>*</span>应用空间
            </span>
          ),
          dataIndex: 'itemId',
          width: 120,
          render: (text, record, index) => (
            <div>
              <Form.Item>
                <Select
                  style={{ width: '100%' }}
                  onChange={e => handleChange(e, index)}
                  // allowClear
                  value={text}
                  options={submitData?.budgetItemList}
                  fieldNames={{ label: 'showName', value: 'id' }}
                />
              </Form.Item>
            </div>
          ),
        },
        {
          title: (
            <span>
              <span style={{ color: 'red', display: type === 'GENERAL' ? 'none' : 'inline' }}>
                *
              </span>
              预算量计算式
            </span>
          ),
          dataIndex: 'budgetQtyFormular',
          width: 100,
          render: (text, record, index) => (
            <div>
              <Form.Item>
                <Input
                  value={text}
                  disabled={
                    (!recordData?.updateBudgetQtyFormularFlag && type === 'GENERAL') ||
                    newSpaceData.errMessage
                  }
                  onChange={e => {
                    onChangeCalculate(index, e.target.value)
                  }}
                ></Input>
              </Form.Item>
            </div>
          ),
        },
        {
          title: '预算量',
          dataIndex: 'budgetQtyValue',
          width: 100,
          render: (text, record, index) => {
            if (record?.budgetQtyFormular && !text) {
              text = '计算式错误'
            }
            return (
              <div>
                <Form.Item>
                  <Input disabled value={text}></Input>
                </Form.Item>
              </div>
            )
          },
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 100,
          render: (text, record, index) => (
            <div>
              <Form.Item>
                <TextArea
                  autoSize
                  disabled={newSpaceData.errMessage}
                  value={text}
                  maxLength={255}
                  onChange={e => {
                    let list: any = dataRef?.current || []
                    const newData = _.cloneDeep(list)
                    newData[index].remark = e.target.value
                    setNewSpaceData({ ...newSpaceData, list: newData })
                  }}
                ></TextArea>
              </Form.Item>
            </div>
          ),
        },
        {
          title: '操作',
          dataIndex: 'handle',
          width: 100,
          align: 'left',
          render: (text, record, index) => (
            <div>
              <Button
                type="link"
                style={{ paddingLeft: 0 }}
                onClick={() => clickToDelete(index)}
                // disabled={record?.itemId === spaceId}
              >
                删除
              </Button>
            </div>
          ),
        },
      ]
    }
    setColumns([...columns])
    setNewSpaceData(newData)
  }, [submitData])
  const handleChange = (value, index) => {
    const newData = _.cloneDeep(dataRef?.current || [])
    newData[index].itemId = value
    setNewSpaceData({ ...newSpaceData, list: newData })
  }

  const onChangeCalculate = (index, val) => {
    let list: any = dataRef?.current || []
    console.log(list, 'list')
    const newData = _.cloneDeep(list)

    if (val) {
      let funcRes: any = ''
      try {
        const func = new Function(`return ${val}`)
        funcRes = func()
      } catch (err) {
        funcRes = null
      }
      funcRes = typeof funcRes === 'number' ? Number(funcRes.toFixed(4)) : funcRes
      console.log(funcRes)
      newData[index].budgetQtyFormular = val
      newData[index].budgetQtyValue = funcRes
    } else {
      newData[index].budgetQtyFormular = null
      newData[index].budgetQtyValue = null
    }
    setNewSpaceData({ ...newSpaceData, list: newData })
  }

  const handleAdd = () => {
    const newData = _.cloneDeep(newSpaceData?.list)
    newData.push({
      itemId: spaceId, // 空间标识id,
      remark: '',
      budgetQtyValue: '',
      budgetQtyFormular: '',
      key: uniqueId(),
    })
    setNewSpaceData({ ...newSpaceData, list: newData })
  }
  const clickToDelete = index => {
    const newData = _.cloneDeep(dataRef.current)
    console.log(newData)
    console.log(index)
    newData.splice(index, 1)
    setNewSpaceData({ ...newSpaceData, list: newData })
    // let index = newData?.findIndex(item => item?.key === record.key)
  }

  useImperativeHandle(ref, () => ({
    spaceData: dataRef.current,
  }))
  return (
    <div className={styles.spaceApplyBox}>
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 12,
            marginTop: 12,
          }}
        >
          <div style={{ fontSize: '14px', fontWeight: 600, color: '#2D2D2E' }}>应用空间</div>
          <Button
            type="primary"
            onClick={handleAdd}
            disabled={newSpaceData?.list?.length >= submitData?.budgetItemList?.length}
          >
            添加空间
          </Button>
        </div>
        <Table
          rowClassName={() => 'editable-row'}
          dataSource={newSpaceData?.list}
          columns={columns}
          pagination={false}
        />
      </div>
    </div>
  )
})
